export const ProductTargetingExpressionNodeQueryDescriptions = {
  key: "Product attribute to filter on. Determines which product property is evaluated.",
  value:
    "Expected value. String for text attributes (productId, collection, tag); number for numeric attributes (price, inventory).",
  filter:
    "Comparison operator for evaluating the product attribute against the value.",
  type: "Mirrors the key field. Determines attribute category for validation.",
} as const;

export const ExperienceProductTargetingDtoDescriptions = {
  id: "Server-generated. Read-only.",
  experienceId: "References the parent experience.",
  target:
    "Storefront context where targeting rules are evaluated (product detail pages vs collection/search listings).",
  expression:
    "Boolean expression tree of product attribute conditions. Each node has either a 'query' (leaf) or 'operator' (combinator).",
} as const;
